import { Observable } from 'rxjs/Observable';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Activity, Objective, Project, Icons, ActivityTaxonomy } from 'toolbandi-ui-lib';
import { SharedDataService, CrudService, MessageService, Breadcrumb, enumToArray } from 'elbuild-ui-lib-core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { of, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'app-activity-edit',
	templateUrl: './activity-edit.component.html',
	styleUrls: ['./activity-edit.component.scss']
})
export class ActivityEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	activity: Activity;
	objective: Objective;
	title: string;
	error: boolean;
	breadcrumb: Breadcrumb;
	project: any;


	activitytypes = enumToArray(ActivityTaxonomy);

	constructor(
		private route: ActivatedRoute,
		private sharedDataService: SharedDataService,
		private activityService: CrudService<Activity>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private objectiveService: CrudService<Objective>,
		private projectService: CrudService<Project>,
		private router: Router
	) { console.log(this.activitytypes); }
	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const aid = +params['aid'];
			const oid = +params['oid'];
			if (aid) {
				this.load(aid);
			} else {
				this.activity = new Activity();
				this.title = 'activity-create';
				if (oid) {
					this.activity.objectiveid = oid;
					this.findObjective(this.activity.objectiveid).subscribe((data) => {
						if (this.objective)
							this.findProject(this.objective.projectid).subscribe(d => { this.setBreadcrumb(); }); // FIXME usare sempre inititem
					});
				}
				this.loading = false;
			}
		});
	}

	load(id: number): void {
		this.loading = true;
		this.activityService.getEntity(Activity, 'activity', id).subscribe(obj => {
			this.activity = obj;
			this.loading = false;
			if (this.activity) {
				this.error = false;
				this.title = 'activity-edit';
				this.initItem();
			} else {
				this.error = true;
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.activity'));
			this.activity = undefined;
			this.loading = false;
			this.error = true;
		});

	}


	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.companies', url: '/company' },
			{ title: this.project.company.name, url: '/company/view/' + this.project.company.id, icon: Icons.COMPANY, icontooltip: 'labels.company' },
			{ title: 'labels.view-project', url: '/company/project/view/' + this.project.id, fragment: 'obiettivi', param: this.project.name, icon: Icons.PROJECT, icontooltip: 'labels.project' }
		];

		if (this.activity.id) {
			this.breadcrumb.title = { title: 'labels.activity-edit', param: this.activity.name, icon: Icons.OBJECTIVE, icontooltip: 'labels.activity' };

		} else {
			this.breadcrumb.title = { title: 'labels.activity-create', param: '', icon: Icons.OBJECTIVE, icontooltip: 'labels.activity' };

		}
	}

	findObjective(oid: number): Observable<boolean> {
		if (oid) {
			return this.objectiveService.getEntity(Objective, 'objective', oid).pipe(map((o: Objective) => {
				this.objective = o;
				return true;
			}));
		} else return of(false);
	}

	findProject(pid: number): Observable<boolean> {
		if (pid) {
			return this.projectService.getEntity(Project, 'project', pid).pipe(map((p: Project) => {
				this.project = p;
				return true;
			}));
		} else return of(false);
	}

	initItem(): void {


		this.findObjective(this.activity.objectiveid);
		this.findProject(this.activity.projectid);


		const objrequest = this.findObjective(this.activity.objectiveid);
		const actrequest = this.findProject(this.activity.projectid);

		forkJoin([objrequest, actrequest]).subscribe(results => {
			this.setBreadcrumb();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	submit(): void {
		this.activity.projectid = this.objective.projectid;

		if (this.activity.stopdate < this.activity.startdate) {
			this.messageService.sendError(
				this.translateService.instant('errors.activity-1'));
			return;
		}

		if (this.activity.startdate < this.objective.startdate || this.activity.startdate > this.objective.stopdate
			|| this.activity.stopdate < this.objective.startdate || this.activity.stopdate > this.objective.stopdate) {
			this.messageService.sendError(
				this.translateService.instant('errors.activity-2'));
			return;
		}


		if (!this.activity.id) {
			this.activityService.createEntity(Activity, 'activity', this.activity).subscribe(response => {
				this.activity = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.activity-save-success'),
					this.translateService.instant('labels.success')
				);
				this.router.navigate(['/company/project/view/', this.objective.projectid], { fragment: 'obiettivi' });

			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.activityService.saveEntity(Activity, 'activity', this.activity).subscribe(response => {
				this.activity = response;
				this.initItem();
				this.messageService.sendSuccess(
					this.translateService.instant('labels.activity-save-success'),
					this.translateService.instant('labels.success')
				);
				this.router.navigate(['/company/project/view/', this.objective.projectid], { fragment: 'obiettivi' });
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	max(d1: Date, d2: Date): Date {
		return d1 >= d2 ? d1 : d2;
	}

}
